module.exports = __webpack_public_path__ + "img/title.e3517209.svg";